import React, { useState, useEffect, useContext, useRef } from "react"
import { AuthContext } from "../App"
import { useTheme } from "../contexts/ThemeContext"
import { Link } from "react-router-dom";
import {
  Search,
  X,
  AlertTriangle,
  MessageCircle,
  FileText,
  Filter,
  RefreshCw,
  Trash2,
  Save,
  CheckSquare,
  ChevronDown,
  ChevronLeft,
  ChevronRight,
  Settings,
  Calendar,
  Users,
  Package,
  Building2,
  CheckCircle,
  Loader,
  Scissors,
  Sparkles,
  Upload,
  Edit,
  Eye
} from "lucide-react"
import "./GestionPedidos.css"
import AlbaranMixtoCrearModal from "../components/AlbaranMixtoCrearModal"
import AlbaranMasivoModal from "../components/AlbaranMasivoModal"

const API_URL = process.env.REACT_APP_API_URL;

// Componente del Panel Lateral
const SidePanel = ({ 
  isOpen, 
  setIsOpen,
  estadoFiltro,
  setEstadoFiltro,
  fechaDesdeFiltro,
  setFechaDesdeFiltro,
  fechaHastaFiltro,
  setFechaHastaFiltro,
  npedidoFiltro,
  setNpedidoFiltro,
  clienteFiltro,
  setClienteFiltro,
  proveedorFiltro,
  setProveedorFiltro,
  handleSubmitFiltros,
  handleLimpiarFiltros,
  loading,
  proveedores,
  user,
  pedidosSeleccionados,
  estadoMasivo,
  setEstadoMasivo,
  handleActualizarEstados,
  handleEliminarPedidos,
  onAsignarAlbaranMasivo,
  onEliminarAlbaranes,
  albaranesSeleccionadosCount = 0,
  eliminandoAlbaranes = false,
  totalPedidos
}) => {
  return (
    <>
      {/* Toggle Button */}
      <button
        onClick={() => setIsOpen(!isOpen)}
        className="fixed left-4 top-1/2 transform -translate-y-1/2 z-50 bg-white border border-gray-300 rounded-r-lg p-3 shadow-lg hover:bg-gray-50 transition-all duration-300"
        style={{
          left: isOpen ? '384px' : '4px'
        }}
      >
        {isOpen ? <ChevronLeft size={20} className="text-gray-600" /> : <ChevronRight size={20} className="text-gray-600" />}
      </button>

      {/* Side Panel */}
      <div 
        className="fixed left-0 top-16 bottom-0 bg-white border-r border-gray-200 shadow-lg transition-transform duration-300 z-40 overflow-hidden"
        style={{
          width: '380px',
          transform: isOpen ? 'translateX(0)' : 'translateX(-100%)'
        }}
      >
        <div className="h-full flex flex-col">
          
          {/* Panel Header */}
          <div className="p-4 border-b border-gray-200 bg-gradient-to-r from-teal-50 to-green-50">
            <div className="flex items-center justify-between mb-2">
              <h2 className="text-lg font-semibold text-gray-800 flex items-center">
                <Settings size={20} className="mr-2 text-teal-600" />
                Panel de Control
              </h2>
            </div>
            <p className="text-sm text-gray-600">
              Filtros avanzados y acciones masivas para gestión de pedidos
            </p>
          </div>

          <div className="flex-1 overflow-y-auto">
            
            {/* SECCIÓN 1: Filtros de Búsqueda */}
            <div className="border-b-4 border-teal-300 bg-gradient-to-r from-teal-50 to-emerald-50">
              <div className="p-4">
                
                <form onSubmit={handleSubmitFiltros} className="space-y-4">
                  {/* N° Pedido */}
                  <div>
                    <label className="block text-xs font-medium text-gray-700 mb-2 flex items-center">
                      <Package size={12} className="mr-1 text-gray-500" />
                      N° Pedido
                    </label>
                    <input
                      type="text"
                      className="block w-full px-3 py-2 text-sm border border-gray-300 focus:outline-none focus:ring-2 focus:ring-teal-500 focus:border-teal-500 rounded-lg shadow-sm transition-colors bg-white"
                      placeholder="ID del pedido..."
                      value={npedidoFiltro}
                      onChange={(e) => setNpedidoFiltro(e.target.value)}
                    />
                  </div>
                  
                  {/* Cliente */}
                  <div>
                    <label className="block text-xs font-medium text-gray-700 mb-2 flex items-center">
                      <Users size={12} className="mr-1 text-gray-500" />
                      Cliente
                    </label>
                    <input
                      type="text"
                      className="block w-full px-3 py-2 text-sm border border-gray-300 focus:outline-none focus:ring-2 focus:ring-teal-500 focus:border-teal-500 rounded-lg shadow-sm transition-colors bg-white"
                      placeholder="Razón social..."
                      value={clienteFiltro}
                      onChange={(e) => setClienteFiltro(e.target.value)}
                    />
                  </div>
                  
                  {/* Proveedor */}
                  <div>
                    <label className="block text-xs font-medium text-gray-700 mb-2 flex items-center">
                      <Building2 size={12} className="mr-1 text-gray-500" />
                      Proveedor
                    </label>
                    <div className="relative">
                      <select
                        className="block w-full px-3 py-2 text-sm border border-gray-300 focus:outline-none focus:ring-2 focus:ring-teal-500 focus:border-teal-500 rounded-lg shadow-sm transition-colors appearance-none bg-white"
                        value={proveedorFiltro}
                        onChange={(e) => setProveedorFiltro(e.target.value)}
                      >
                        <option value="">Todos los proveedores</option>
                        {proveedores.map((proveedor) => (
                          <option key={proveedor.id} value={proveedor.id}>
                            {proveedor.nombre}
                          </option>
                        ))}
                      </select>
                      <div className="absolute inset-y-0 right-0 flex items-center px-2 pointer-events-none">
                        <ChevronDown size={14} className="text-gray-500" />
                      </div>
                    </div>
                  </div>
                  
                  {/* Estado */}
                  <div>
                    <label className="block text-xs font-medium text-gray-700 mb-2 flex items-center">
                      <CheckCircle size={12} className="mr-1 text-gray-500" />
                      Estado
                    </label>
                    <div className="relative">
                      <select
                        className="block w-full px-3 py-2 text-sm border border-gray-300 focus:outline-none focus:ring-2 focus:ring-teal-500 focus:border-teal-500 rounded-lg shadow-sm transition-colors appearance-none bg-white"
                        value={estadoFiltro}
                        onChange={(e) => setEstadoFiltro(e.target.value)}
                      >
                        <option value="">Todos los estados</option>
                        <option value="1">Abierto</option>
                        <option value="2">En proceso</option>
                        <option value="3">Enviado</option>
                        <option value="4">Envío parcial</option>
                        <option value="5">Cerrado</option>
                      </select>
                      <div className="absolute inset-y-0 right-0 flex items-center px-2 pointer-events-none">
                        <ChevronDown size={14} className="text-gray-500" />
                      </div>
                    </div>
                  </div>

                  {/* Rango de fechas */}
                  <div className="bg-white rounded-lg p-3 border border-teal-200 shadow-sm">
                    <h4 className="font-medium text-teal-800 mb-3 text-xs flex items-center">
                      <Calendar size={14} className="mr-1" />
                      Rango de Fechas
                    </h4>
                    
                    <div className="space-y-3">
                      <div>
                        <label className="block text-xs font-medium text-gray-700 mb-1">Fecha desde</label>
                        <input
                          type="date"
                          className="block w-full px-3 py-2 text-sm border border-gray-300 focus:outline-none focus:ring-2 focus:ring-teal-500 focus:border-teal-500 rounded-lg shadow-sm transition-colors bg-white"
                          value={fechaDesdeFiltro}
                          onChange={(e) => setFechaDesdeFiltro(e.target.value)}
                        />
                      </div>
                      
                      <div>
                        <label className="block text-xs font-medium text-gray-700 mb-1">Fecha hasta</label>
                        <input
                          type="date"
                          className="block w-full px-3 py-2 text-sm border border-gray-300 focus:outline-none focus:ring-2 focus:ring-teal-500 focus:border-teal-500 rounded-lg shadow-sm transition-colors bg-white"
                          value={fechaHastaFiltro}
                          onChange={(e) => setFechaHastaFiltro(e.target.value)}
                        />
                      </div>
                    </div>
                  </div>

                  {/* Botones de filtros */}
                  <div className="grid grid-cols-1 gap-2">
                    <button
                      type="submit"
                      className="flex items-center justify-center px-4 py-2 bg-teal-500 text-white rounded-lg hover:bg-teal-600 focus:outline-none focus:ring-2 focus:ring-teal-500 focus:ring-offset-2 transition-all duration-200 shadow-sm font-medium text-sm"
                      disabled={loading}
                    >
                      {loading ? (
                        <>
                          <Loader size={16} className="mr-2 animate-spin" />
                          Buscando...
                        </>
                      ) : (
                        <>
                          <Search size={16} className="mr-2" />
                          Buscar Pedidos
                        </>
                      )}
                    </button>
                    
                    <button
                      type="button"
                      onClick={handleLimpiarFiltros}
                      className="flex items-center justify-center px-4 py-2 bg-gray-200 text-gray-700 rounded-lg hover:bg-gray-300 focus:outline-none focus:ring-2 focus:ring-gray-400 transition-colors shadow-sm font-medium text-sm"
                    >
                      <RefreshCw size={14} className="mr-2" />
                      Limpiar Filtros
                    </button>
                  </div>
                </form>
              </div>
            </div>

            {/* SEPARADOR VISUAL */}
            <div className="h-4 bg-gradient-to-r from-gray-100 to-gray-200"></div>

            {/* SECCIÓN 2: Acciones Masivas */}
            {user && user.permisos !== 5 && (
              <div className="bg-gradient-to-r from-orange-50 to-amber-50">
                <div className="p-4">
                  
                  <div className="space-y-4">
                    {/* Estados para cambio masivo */}
                    <div className="bg-white rounded-lg p-3 border border-orange-200 shadow-sm">
                      <h4 className="font-medium text-orange-800 mb-3 text-xs">Cambiar Estado</h4>
                      
                      <div className="space-y-2">
                        <div className="flex items-center bg-gray-50 border border-gray-200 rounded-lg px-3 py-2 transition-colors hover:bg-gray-100">
                          <input
                            type="radio"
                            id="estadoEnviado"
                            name="estado_masivo"
                            value="3"
                            checked={estadoMasivo === "3"}
                            onChange={(e) => setEstadoMasivo(e.target.value)}
                            className="h-3 w-3 mr-2 cursor-pointer accent-teal-500"
                          />
                          <label htmlFor="estadoEnviado" className="cursor-pointer text-xs font-medium">
                            Enviado
                          </label>
                        </div>
                        
                        <div className="flex items-center bg-gray-50 border border-gray-200 rounded-lg px-3 py-2 transition-colors hover:bg-gray-100">
                          <input
                            type="radio"
                            id="estadoParcial"
                            name="estado_masivo"
                            value="4"
                            checked={estadoMasivo === "4"}
                            onChange={(e) => setEstadoMasivo(e.target.value)}
                            className="h-3 w-3 mr-2 cursor-pointer accent-teal-500"
                          />
                          <label htmlFor="estadoParcial" className="cursor-pointer text-xs font-medium">
                            Envío Parcial
                          </label>
                        </div>
                        
                        <div className="flex items-center bg-gray-50 border border-gray-200 rounded-lg px-3 py-2 transition-colors hover:bg-gray-100">
                          <input
                            type="radio"
                            id="estadoCerrado"
                            name="estado_masivo"
                            value="5"
                            checked={estadoMasivo === "5"}
                            onChange={(e) => setEstadoMasivo(e.target.value)}
                            className="h-3 w-3 mr-2 cursor-pointer accent-teal-500"
                          />
                          <label htmlFor="estadoCerrado" className="cursor-pointer text-xs font-medium">
                            Cerrado
                          </label>
                        </div>
                      </div>
                    </div>
                    
                    {/* Botones de acción */}
                    <div className="grid grid-cols-1 gap-2">
                      <button
                        type="button"
                        onClick={handleActualizarEstados}
                        disabled={pedidosSeleccionados.length === 0 || !estadoMasivo}
                        className={`flex items-center justify-center px-4 py-2 rounded-lg transition-colors shadow-sm font-medium text-sm ${
                          pedidosSeleccionados.length === 0 || !estadoMasivo
                            ? "bg-gray-300 text-gray-500 cursor-not-allowed"
                            : "bg-green-500 hover:bg-green-600 text-white focus:outline-none focus:ring-2 focus:ring-green-500"
                        }`}
                      >
                        <Save size={14} className="mr-2" />
                        Actualizar Estados
                      </button>
                      
                      <button
                        type="button"
                        onClick={handleEliminarPedidos}
                        disabled={pedidosSeleccionados.length === 0}
                        className={`flex items-center justify-center px-4 py-2 rounded-lg transition-colors shadow-sm font-medium text-sm ${
                          pedidosSeleccionados.length === 0
                            ? "bg-gray-300 text-gray-500 cursor-not-allowed"
                            : "bg-red-500 hover:bg-red-600 text-white focus:outline-none focus:ring-2 focus:ring-red-500"
                        }`}
                      >
                        <Trash2 size={14} className="mr-2" />
                        Eliminar Seleccionados
                      </button>

                      <button
                        type="button"
                        onClick={onAsignarAlbaranMasivo}
                        disabled={pedidosSeleccionados.length === 0}
                        className={`flex items-center justify-center px-4 py-2 rounded-lg transition-colors shadow-sm font-medium text-sm ${
                          pedidosSeleccionados.length === 0
                            ? "bg-gray-300 text-gray-500 cursor-not-allowed"
                            : "bg-teal-500 hover:bg-teal-600 text-white focus:outline-none focus:ring-2 focus:ring-teal-500"
                        }`}
                        title="Asignar número de albarán y datos de stock (lote/fecha) a varios pedidos de una vez"
                      >
                        <FileText size={14} className="mr-2" />
                        Asignar albarán masivo
                      </button>

                      <button
                        type="button"
                        onClick={onEliminarAlbaranes}
                        disabled={albaranesSeleccionadosCount === 0 || eliminandoAlbaranes}
                        className={`flex items-center justify-center px-4 py-2 rounded-lg transition-colors shadow-sm font-medium text-sm ${
                          albaranesSeleccionadosCount === 0 || eliminandoAlbaranes
                            ? "bg-gray-300 text-gray-500 cursor-not-allowed"
                            : "bg-red-500 hover:bg-red-600 text-white focus:outline-none focus:ring-2 focus:ring-red-500"
                        }`}
                        title="Eliminar los PDFs de albarán de los pedidos seleccionados"
                      >
                        {eliminandoAlbaranes ? (
                          <Loader size={14} className="mr-2 animate-spin" />
                        ) : (
                          <Trash2 size={14} className="mr-2" />
                        )}
                        Eliminar albaranes{albaranesSeleccionadosCount > 0 ? ` (${albaranesSeleccionadosCount})` : ""}
                      </button>
                    </div>
                  </div>
                </div>
              </div>
            )}

            
          </div>
        </div>
      </div>
    </>
  );
};

const GestionPedidos = () => {
  const { user } = useContext(AuthContext)
  const { theme: themeCtx } = useTheme()
  const theme = {
    primary:       themeCtx?.primary       || '#3cbf9a',
    primaryDark:   themeCtx?.primaryDark   || '#2da080',
    primaryLight:  themeCtx?.primaryLight  || 'rgba(60, 191, 154, 0.10)',
    primaryBorder: themeCtx?.primaryBorder || 'rgba(60, 191, 154, 0.20)',
  }
  const comentariosModalRef = useRef(null)

  // Estados para filtros
  const [estadoFiltro, setEstadoFiltro] = useState("")
  const [fechaDesdeFiltro, setFechaDesdeFiltro] = useState("")
  const [fechaHastaFiltro, setFechaHastaFiltro] = useState("")
  const [npedidoFiltro, setNpedidoFiltro] = useState("")
  const [clienteFiltro, setClienteFiltro] = useState("")
  const [proveedorFiltro, setProveedorFiltro] = useState("")

  // Estados para control de carga
  const [pedidos, setPedidos] = useState([])
  const [proveedores, setProveedores] = useState([])
  const [loading, setLoading] = useState(true)
  const [error, setError] = useState(null)
  const [loadingPdf, setLoadingPdf] = useState(false)

  // Estados para selección
  const [pedidosSeleccionados, setPedidosSeleccionados] = useState([])
  const [estadoMasivo, setEstadoMasivo] = useState("")

  // Estados para comentarios
  const [comentarios, setComentarios] = useState([])
  const [nuevoComentario, setNuevoComentario] = useState("")
  const [pedidoSeleccionadoId, setPedidoSeleccionadoId] = useState(null)
  const [comentariosModalVisible, setComentariosModalVisible] = useState(false)

  // Estados para totales
  const [totalPedidos, setTotalPedidos] = useState(0)

  // Estado para el panel lateral
  const [sidePanelOpen, setSidePanelOpen] = useState(true)

  // ESTADOS PARA GESTIÓN DE FACTURAS INDIVIDUALES
  const [showInvoiceModal, setShowInvoiceModal] = useState(false)
  const [selectedPedidoForInvoice, setSelectedPedidoForInvoice] = useState(null)
  const [invoiceFile, setInvoiceFile] = useState(null)
  const [uploadingInvoice, setUploadingInvoice] = useState(false)

  // ESTADOS PARA SUBIDA DEL PDF DEL ALBARÁN
  const [showAlbaranModal, setShowAlbaranModal] = useState(false)
  const [selectedPedidoForAlbaran, setSelectedPedidoForAlbaran] = useState(null)
  const [albaranFile, setAlbaranFile] = useState(null)
  const [albaranFechaEntrega, setAlbaranFechaEntrega] = useState('')
  const [uploadingAlbaran, setUploadingAlbaran] = useState(false)
  // Mapa pedidoId -> [albaranes] para indicar qué pedidos ya tienen albarán subido
  const [albaranesPorPedido, setAlbaranesPorPedido] = useState({})
  const [eliminandoAlbaranes, setEliminandoAlbaranes] = useState(false)

  // NUEVOS ESTADOS PARA GESTIÓN DE FACTURAS MASIVAS
  const [showBulkInvoiceModal, setShowBulkInvoiceModal] = useState(false)
  const [bulkInvoiceFiles, setBulkInvoiceFiles] = useState([])
  const [uploadingBulkInvoices, setUploadingBulkInvoices] = useState(false)
  const [bulkUploadResults, setBulkUploadResults] = useState(null)

  // ESTADOS PARA CARGA MASIVA DE ALBARANES (match nombre de archivo -> pedido)
  const [showBulkAlbaranModal, setShowBulkAlbaranModal] = useState(false)
  const [bulkAlbaranFiles, setBulkAlbaranFiles] = useState([])
  const [uploadingBulkAlbaranes, setUploadingBulkAlbaranes] = useState(false)
  const [bulkAlbaranResults, setBulkAlbaranResults] = useState(null)

  // ✅ FUNCIÓN: Badge para tipo de pedido
  const getTipoBadge = (tipo, clienteId, clinicaMatriz) => {
    // Solo mostrar para clientes 131, 999999 y derivados
    if (![131, 999999].includes(clienteId) && ![131, 999999].includes(clinicaMatriz)) {
      return null;
    }

    if (tipo === 'cirugia_plastica') {
      return (
        <span className="inline-flex items-center px-2 py-1 rounded-full text-xs font-medium bg-teal-100 text-teal-800">
          <Scissors size={12} className="mr-1" />
          Cirugía Plástica
        </span>
      );
    }

    if (tipo === 'medicina_estetica') {
      return (
        <span className="inline-flex items-center px-2 py-1 rounded-full text-xs font-medium bg-purple-100 text-purple-800">
          <Sparkles size={12} className="mr-1" />
          Medicina Estética
        </span>
      );
    }

    return null;
  };

  // FUNCIÓN: Abrir modal de factura individual
  const openInvoiceModal = (pedido) => {
    // Si ya existe factura, permitir modificar sin validar estado
    if (!pedido.pdf_factura) {
      // Solo validar estado si NO existe factura
      if (![3, 4, 5].includes(pedido.estado)) {
        alert('Solo se pueden subir facturas a pedidos con estado Enviado, Envío parcial o Cerrado');
        return;
      }
    }
    
    setSelectedPedidoForInvoice(pedido);
    setShowInvoiceModal(true);
    setInvoiceFile(null);
  };

  // FUNCIÓN: Manejar cambio de archivo individual
  const handleInvoiceFileChange = (e) => {
    const file = e.target.files[0];
    if (file) {
      if (file.type !== 'application/pdf') {
        alert('Solo se permiten archivos PDF');
        return;
      }
      if (file.size > 50 * 1024 * 1024) {
        alert('El archivo no puede superar los 50MB');
        return;
      }
      setInvoiceFile(file);
    }
  };

  // FUNCIÓN: Subir factura individual
  const uploadInvoice = async () => {
    if (!invoiceFile || !selectedPedidoForInvoice) return;

    try {
      setUploadingInvoice(true);
      const token = localStorage.getItem('token');
      
      const formData = new FormData();
      formData.append('file', invoiceFile);

      const response = await fetch(`${API_URL}/api/invoicing/pedidos/${selectedPedidoForInvoice.id}/upload-invoice`, {
        method: 'POST',
        headers: {
          'Authorization': `Bearer ${token}`
        },
        body: formData
      });

      if (response.ok) {
        const isModifying = selectedPedidoForInvoice.pdf_factura;
        alert(isModifying ? 'Factura modificada correctamente' : 'Factura subida correctamente');
        setShowInvoiceModal(false);
        setInvoiceFile(null);
        setSelectedPedidoForInvoice(null);
        
        // Recargar pedidos
        window.location.reload();
      } else {
        const data = await response.json();
        alert(data.message || 'Error al subir la factura');
      }
    } catch (error) {
      console.error('Error al subir factura:', error);
      alert('Error al subir la factura');
    } finally {
      setUploadingInvoice(false);
    }
  };

  // FUNCIÓN: Abrir modal de subida del PDF del albarán
  const openAlbaranModal = (pedido) => {
    setSelectedPedidoForAlbaran(pedido);
    setAlbaranFile(null);
    setAlbaranFechaEntrega('');
    setShowAlbaranModal(true);
  };

  // FUNCIÓN: Manejar cambio de archivo del albarán
  const handleAlbaranFileChange = (e) => {
    const file = e.target.files[0];
    if (file) {
      if (file.type !== 'application/pdf') {
        alert('Solo se permiten archivos PDF');
        return;
      }
      if (file.size > 50 * 1024 * 1024) {
        alert('El archivo no puede superar los 50MB');
        return;
      }
      setAlbaranFile(file);
    }
  };

  // FUNCIÓN: Subir PDF del albarán
  const uploadAlbaranPdf = async () => {
    if (!albaranFile || !selectedPedidoForAlbaran) return;

    try {
      setUploadingAlbaran(true);
      const token = localStorage.getItem('token');

      const formData = new FormData();
      formData.append('file', albaranFile);
      if (albaranFechaEntrega) formData.append('fecha_entrega', albaranFechaEntrega);

      const response = await fetch(`${API_URL}/api/pedidos/${selectedPedidoForAlbaran.id}/albaran-pdf`, {
        method: 'POST',
        headers: {
          'Authorization': `Bearer ${token}`
        },
        body: formData
      });

      if (response.ok) {
        const data = await response.json();
        const pedidoId = selectedPedidoForAlbaran.id;
        // Reflejar el nuevo albarán en el indicador sin recargar.
        if (data.albaran) {
          setAlbaranesPorPedido((prev) => ({
            ...prev,
            [pedidoId]: [
              ...(prev[pedidoId] || []),
              { id: data.albaran.id, nombre: data.albaran.nombre, url: data.albaran.url, fecha_entrega: albaranFechaEntrega || null },
            ],
          }));
        }
        alert('Albarán subido correctamente');
        setShowAlbaranModal(false);
        setAlbaranFile(null);
        setAlbaranFechaEntrega('');
        setSelectedPedidoForAlbaran(null);
      } else {
        const data = await response.json();
        alert(data.message || 'Error al subir el albarán');
      }
    } catch (error) {
      console.error('Error al subir albarán:', error);
      alert('Error al subir el albarán');
    } finally {
      setUploadingAlbaran(false);
    }
  };

  // Nº total de albaranes (PDFs) en los pedidos seleccionados.
  const albaranesSeleccionadosCount = pedidosSeleccionados.reduce(
    (acc, pid) => acc + ((albaranesPorPedido[pid] || []).length), 0
  );

  // FUNCIÓN: Eliminar los PDFs de albarán de los pedidos seleccionados.
  const handleEliminarAlbaranesMasivo = async () => {
    const objetivos = pedidosSeleccionados.filter(
      (pid) => (albaranesPorPedido[pid] || []).length > 0
    );
    if (objetivos.length === 0) return;

    const total = albaranesSeleccionadosCount;
    if (!window.confirm(
      `¿Eliminar ${total} albarán${total === 1 ? '' : 'es'} de ${objetivos.length} pedido${objetivos.length === 1 ? '' : 's'}? Esta acción no se puede deshacer.`
    )) return;

    try {
      setEliminandoAlbaranes(true);
      const token = localStorage.getItem('token');
      const fallidos = [];

      for (const pid of objetivos) {
        for (const alb of (albaranesPorPedido[pid] || [])) {
          try {
            const r = await fetch(`${API_URL}/api/albaranes/${alb.id}`, {
              method: 'DELETE',
              headers: { 'Authorization': `Bearer ${token}` },
            });
            if (!r.ok) fallidos.push(alb.id);
          } catch {
            fallidos.push(alb.id);
          }
        }
      }

      // Actualizar el mapa quitando los albaranes borrados con éxito.
      setAlbaranesPorPedido((prev) => {
        const next = { ...prev };
        for (const pid of objetivos) {
          const restantes = (next[pid] || []).filter((a) => fallidos.includes(a.id));
          if (restantes.length > 0) next[pid] = restantes;
          else delete next[pid];
        }
        return next;
      });

      if (fallidos.length > 0) {
        alert(`Se eliminaron los albaranes, pero ${fallidos.length} no se pudieron borrar.`);
      } else {
        alert('Albaranes eliminados correctamente');
      }
    } catch (error) {
      console.error('Error al eliminar albaranes:', error);
      alert('Error al eliminar los albaranes');
    } finally {
      setEliminandoAlbaranes(false);
    }
  };

  // FUNCIÓN: Ver factura
  const viewInvoice = async (pedidoId) => {
    try {
      const token = localStorage.getItem('token');
      
      const response = await fetch(`${API_URL}/api/invoicing/pedidos/${pedidoId}/invoice`, {
        headers: {
          'Authorization': `Bearer ${token}`
        }
      });
      
      if (response.ok) {
        const data = await response.json();
        window.open(data.pdf_url, '_blank');
      } else {
        const data = await response.json();
        alert(data.message || 'Error al obtener la factura');
      }
    } catch (error) {
      console.error('Error al ver factura:', error);
      alert('Error al ver la factura');
    }
  };

  // FUNCIÓN: Eliminar factura
  const deleteInvoice = async (pedidoId) => {
    if (!window.confirm('¿Estás seguro de que deseas eliminar esta factura?')) {
      return;
    }

    try {
      const token = localStorage.getItem('token');
      
      const response = await fetch(`${API_URL}/api/invoicing/pedidos/${pedidoId}/invoice`, {
        method: 'DELETE',
        headers: {
          'Authorization': `Bearer ${token}`
        }
      });
      
      if (response.ok) {
        alert('Factura eliminada correctamente');
        window.location.reload();
      } else {
        const data = await response.json();
        alert(data.message || 'Error al eliminar la factura');
      }
    } catch (error) {
      console.error('Error al eliminar factura:', error);
      alert('Error al eliminar la factura');
    }
  };

  // NUEVA FUNCIÓN: Manejar selección de archivos masivos
  const handleBulkInvoiceFilesChange = (e) => {
    const files = Array.from(e.target.files);
    const pdfFiles = files.filter(file => file.type === 'application/pdf');
    
    if (pdfFiles.length !== files.length) {
      alert('Solo se permiten archivos PDF. Los archivos que no son PDF han sido ignorados.');
    }
    
    const validFiles = pdfFiles.filter(file => file.size <= 50 * 1024 * 1024);
    
    if (validFiles.length !== pdfFiles.length) {
      alert('Algunos archivos superan el límite de 50MB y no se han agregado');
    }
    
    setBulkInvoiceFiles(prevFiles => [...prevFiles, ...validFiles]);
  };

  // NUEVA FUNCIÓN: Eliminar archivo de la lista
  const removeBulkInvoiceFile = (index) => {
    setBulkInvoiceFiles(prevFiles => prevFiles.filter((_, i) => i !== index));
  };

  // NUEVA FUNCIÓN: Limpiar lista de archivos
  const clearBulkInvoiceFiles = () => {
    setBulkInvoiceFiles([]);
    setBulkUploadResults(null);
  };

  // NUEVA FUNCIÓN: Subir facturas masivamente
  const uploadBulkInvoices = async () => {
    if (bulkInvoiceFiles.length === 0) return;

    try {
      setUploadingBulkInvoices(true);
      setBulkUploadResults(null);
      
      const token = localStorage.getItem('token');
      
      const formData = new FormData();
      bulkInvoiceFiles.forEach(file => {
        formData.append('files', file);
      });

      const response = await fetch(`${API_URL}/api/invoicing/pedidos/upload-invoices-bulk`, {
        method: 'POST',
        headers: {
          'Authorization': `Bearer ${token}`
        },
        body: formData
      });

      if (response.ok) {
        const data = await response.json();
        setBulkUploadResults(data);
        
        // Si todas se subieron correctamente, cerrar modal después de mostrar resultado
        if (data.failed === 0) {
          setTimeout(() => {
            setShowBulkInvoiceModal(false);
            clearBulkInvoiceFiles();
            window.location.reload();
          }, 3000);
        }
      } else {
        const data = await response.json();
        alert(data.message || 'Error al subir las facturas');
      }
    } catch (error) {
      console.error('Error al subir facturas masivamente:', error);
      alert('Error al subir las facturas');
    } finally {
      setUploadingBulkInvoices(false);
    }
  };

  // ── CARGA MASIVA DE ALBARANES ─────────────────────────────────────────
  const handleBulkAlbaranFilesChange = (e) => {
    const files = Array.from(e.target.files);
    const pdfFiles = files.filter(file => file.type === 'application/pdf');
    if (pdfFiles.length !== files.length) {
      alert('Solo se permiten archivos PDF. Los que no lo son han sido ignorados.');
    }
    const validFiles = pdfFiles.filter(file => file.size <= 50 * 1024 * 1024);
    if (validFiles.length !== pdfFiles.length) {
      alert('Algunos archivos superan el límite de 50MB y no se han agregado');
    }
    setBulkAlbaranFiles(prev => [...prev, ...validFiles]);
  };

  const removeBulkAlbaranFile = (index) => {
    setBulkAlbaranFiles(prev => prev.filter((_, i) => i !== index));
  };

  const clearBulkAlbaranFiles = () => {
    setBulkAlbaranFiles([]);
    setBulkAlbaranResults(null);
  };

  const uploadBulkAlbaranes = async () => {
    if (bulkAlbaranFiles.length === 0) return;
    try {
      setUploadingBulkAlbaranes(true);
      setBulkAlbaranResults(null);
      const token = localStorage.getItem('token');
      const formData = new FormData();
      bulkAlbaranFiles.forEach(file => formData.append('files', file));

      const response = await fetch(`${API_URL}/api/albaranes/upload-bulk`, {
        method: 'POST',
        headers: { 'Authorization': `Bearer ${token}` },
        body: formData,
      });

      if (response.ok) {
        const data = await response.json();
        setBulkAlbaranResults(data);
        if (data.failed === 0) {
          setTimeout(() => {
            setShowBulkAlbaranModal(false);
            clearBulkAlbaranFiles();
            window.location.reload();
          }, 2500);
        }
      } else {
        const data = await response.json();
        alert(data.message || 'Error al subir los albaranes');
      }
    } catch (error) {
      console.error('Error al subir albaranes masivamente:', error);
      alert('Error al subir los albaranes');
    } finally {
      setUploadingBulkAlbaranes(false);
    }
  };

  // Obtener pedidos con filtros
  useEffect(() => {
    const fetchPedidos = async () => {
      try {
        console.log("🔍 DEBUGGING - Inicio fetchPedidos");
        console.log("🔍 API_URL:", API_URL);
        
        setLoading(true)
        setError(null)
        
        const token = localStorage.getItem('token')
        console.log("🔍 Token existe:", !!token);
        console.log("🔍 Token (primeros 20 chars):", token ? token.substring(0, 20) : "NO HAY TOKEN");
        
        if (!token) {
          console.log("❌ No hay token, abortando");
          setError("No hay token de autenticación")
          setLoading(false)
          return
        }
        
        const params = new URLSearchParams();
        if (estadoFiltro) params.append('estado', estadoFiltro);
        if (fechaDesdeFiltro) params.append('fecha_desde', fechaDesdeFiltro);
        if (fechaHastaFiltro) params.append('fecha_hasta', fechaHastaFiltro);
        if (npedidoFiltro) params.append('npedido', npedidoFiltro);
        if (clienteFiltro) params.append('cliente', clienteFiltro);
        if (proveedorFiltro) params.append('proveedor', proveedorFiltro);
        
        const queryString = params.toString() ? `?${params.toString()}` : '';
        const fullURL = `${API_URL}/api/pedidos-admin${queryString}`;
        
        console.log("🔍 URL completa:", fullURL);
        console.log("🔍 Query params:", queryString);
        
        const response = await fetch(fullURL, {
          headers: {
            'Authorization': `Bearer ${token}`,
          },
        })
        
        console.log("🔍 Response status:", response.status);
        console.log("🔍 Response ok:", response.ok);
        
        if (!response.ok) {
          const errorText = await response.text();
          console.log("❌ Error response body:", errorText);
          throw new Error("Error al obtener los pedidos")
        }

        const data = await response.json()
        setPedidos(data.pedidos)
        setTotalPedidos(data.total || data.pedidos.length)

        // Indicador de albaranes ya subidos por pedido (no bloquea el listado).
        try {
          const ids = (data.pedidos || []).map((p) => p.id)
          if (ids.length) {
            const albResp = await fetch(`${API_URL}/api/albaranes/por-pedidos`, {
              method: 'POST',
              headers: { 'Authorization': `Bearer ${token}`, 'Content-Type': 'application/json' },
              body: JSON.stringify({ pedido_ids: ids }),
            })
            if (albResp.ok) {
              const albData = await albResp.json()
              setAlbaranesPorPedido(albData.albaranes || {})
            }
          } else {
            setAlbaranesPorPedido({})
          }
        } catch (_) { /* el indicador es opcional */ }
      } catch (error) {
        console.error("Error:", error)
        setError("No se pudieron cargar los pedidos. " + error.message)
      } finally {
        setLoading(false)
      }
    }

    fetchPedidos()
  }, [estadoFiltro, fechaDesdeFiltro, fechaHastaFiltro, npedidoFiltro, clienteFiltro, proveedorFiltro])

  // Obtener proveedores
  useEffect(() => {
    const fetchProveedores = async () => {
      try {
        const token = localStorage.getItem('token')
        
        if (!token) {
          return
        }
        
        const response = await fetch(`${API_URL}/api/proveedores`, {
          headers: {
            Authorization: `Bearer ${token}`,
          },
        })

        if (!response.ok) {
          throw new Error("Error al obtener los proveedores")
        }

        const data = await response.json()
        setProveedores(data.proveedores)
      } catch (error) {
        console.error("Error:", error)
      }
    }

    fetchProveedores()
  }, [])

  // Cerrar modal al hacer clic fuera
  useEffect(() => {
    const handleClickOutside = (event) => {
      if (comentariosModalRef.current && !comentariosModalRef.current.contains(event.target)) {
        setComentariosModalVisible(false)
      }
    }

    document.addEventListener("mousedown", handleClickOutside)
    return () => {
      document.removeEventListener("mousedown", handleClickOutside)
    }
  }, [])

  // Función para actualizar estado de pedidos masivamente
  const handleActualizarEstados = async () => {
    try {
      setLoading(true)
      const token = localStorage.getItem('token')
      
      const response = await fetch(`${API_URL}/api/pedidos/actualizar-estados`, {
        method: "POST",
        headers: {
          Authorization: `Bearer ${token}`,
          "Content-Type": "application/json",
        },
        body: JSON.stringify({
          pedidos_ids: pedidosSeleccionados,
          estado: estadoMasivo,
        }),
      })

      if (!response.ok) {
        throw new Error("Error al actualizar los estados")
      }

      // Actualizar la lista de pedidos
      const pedidosActualizados = pedidos.map((pedido) => {
        if (pedidosSeleccionados.includes(pedido.id)) {
          return { ...pedido, estado: parseInt(estadoMasivo) }
        }
        return pedido
      })

      setPedidos(pedidosActualizados)
      setPedidosSeleccionados([])
      setEstadoMasivo("")
    } catch (error) {
      console.error("Error:", error)
    } finally {
      setLoading(false)
    }
  }

  // Función para eliminar pedidos seleccionados
  const handleEliminarPedidos = async () => {
    if (pedidosSeleccionados.length === 0) {
      return
    }

    const confirmar = window.confirm("¿Estás seguro de que deseas eliminar los pedidos seleccionados?")
    if (!confirmar) return

    try {
      setLoading(true)
      const token = localStorage.getItem('token')
      
      const response = await fetch(`${API_URL}/api/pedidos/eliminar`, {
        method: "POST",
        headers: {
          Authorization: `Bearer ${token}`,
          "Content-Type": "application/json",
        },
        body: JSON.stringify({
          pedidos_ids: pedidosSeleccionados,
        }),
      })

      if (!response.ok) {
        throw new Error("Error al eliminar los pedidos")
      }

      // Filtrar los pedidos eliminados
      const pedidosActualizados = pedidos.filter(
        (pedido) => !pedidosSeleccionados.includes(pedido.id)
      )

      setPedidos(pedidosActualizados)
      setPedidosSeleccionados([])
    } catch (error) {
      console.error("Error:", error)
    } finally {
      setLoading(false)
    }
  }

  // Estado para modal de verificacion de albaran -> stock (modo 'albaran' clásico)
  const [albaranModal, setAlbaranModal] = useState({ open: false, pedidoId: null, data: null })

  // Estado para modal de creación de albarán pendiente (modo 'mixto')
  const [mixtoModal, setMixtoModal] = useState({ open: false, pedidoId: null, albaranNumero: "" })

  // Estado para modal de asignación MASIVA de albaranes a varios pedidos
  const [albaranMasivoModal, setAlbaranMasivoModal] = useState({ open: false, pedidos: [] })

  // Función para actualizar albarán
  const handleUpdateAlbaran = async (pedidoId, albaranValue) => {
    try {
      const token = localStorage.getItem('token')

      const response = await fetch(`${API_URL}/api/pedidos/${pedidoId}/albaran`, {
        method: "PUT",
        headers: {
          Authorization: `Bearer ${token}`,
          "Content-Type": "application/json",
        },
        body: JSON.stringify({
          albaran: albaranValue,
        }),
      })

      if (!response.ok) {
        throw new Error("Error al actualizar el albarán")
      }

      // Actualizar el pedido en el estado
      setPedidos(
        pedidos.map((pedido) =>
          pedido.id === pedidoId ? { ...pedido, albaran: albaranValue } : pedido
        )
      )

      // Si el albaran tiene valor, gestion de stock entra en juego:
      //   - Modos 'albaran' y 'mixto'   → modal de creación de albarán pendiente
      //                                   con lotes + vencimientos. Doble
      //                                   verificación: cliente acepta antes
      //                                   de tocar stock. Aplica a TODOS los
      //                                   roles (admin, proveedor, cliente).
      //   - Otros modos (picking, inactivo) → no se hace nada
      if (albaranValue && albaranValue.trim()) {
        try {
          // /albaran-preview devuelve `modo_stock` aunque el cliente no sea 'albaran',
          // así podemos detectar el modo del cliente sin endpoint extra.
          const previewResp = await fetch(`${API_URL}/api/stock/pedido/${pedidoId}/albaran-preview`, {
            headers: { Authorization: `Bearer ${token}` }
          })
          const previewData = await previewResp.json()

          if (previewData.modo_stock === 'albaran' || previewData.modo_stock === 'mixto') {
            // Flujo unificado: albarán queda pendiente, cliente debe aceptar
            setMixtoModal({ open: true, pedidoId, albaranNumero: albaranValue })
          }
          // Otros modos (picking, inactivo): nada que hacer aquí. El stock se
          // gestiona por el flujo de escaneo desde la app o no se gestiona.
        } catch (e) {
          console.error('Stock albaran flow fallo:', e)
        }
      }
    } catch (error) {
      console.error("Error:", error)
    }
  }
  
  // Función para descargar el PDF de un pedido
  const handleDescargarPDF = async (pedidoId) => {
    try {
      setLoadingPdf(true)
      
      const token = localStorage.getItem('token')
      
      const response = await fetch(`${API_URL}/api/pedidos/${pedidoId}/pdf`, {
        method: 'GET',
        headers: {
          'Authorization': `Bearer ${token}`,
        },
      })
      
      if (!response.ok) {
        throw new Error("Error al descargar el PDF")
      }
      
      const contentDisposition = response.headers.get('content-disposition')
      let filename = `pedido_${pedidoId}.pdf`
      
      if (contentDisposition) {
        const filenameMatch = contentDisposition.match(/filename="(.+)"/)
        if (filenameMatch && filenameMatch.length > 1) {
          filename = filenameMatch[1]
        }
      }
      
      const blob = await response.blob()
      const url = window.URL.createObjectURL(blob)
      const a = document.createElement('a')
      a.style.display = 'none'
      a.href = url
      a.download = filename
      
      document.body.appendChild(a)
      a.click()
      
      window.URL.revokeObjectURL(url)
      document.body.removeChild(a)
      
    } catch (error) {
      console.error("Error:", error)
    } finally {
      setLoadingPdf(false)
    }
  }

  // Función para mostrar modal de comentarios
  const handleShowComentarios = async (pedidoId) => {
    try {
      setPedidoSeleccionadoId(pedidoId)
      setComentariosModalVisible(true)
      setNuevoComentario("")

      const token = localStorage.getItem('token')

      const response = await fetch(`${API_URL}/api/pedidos/${pedidoId}/comentarios-pedido`, {
        headers: {
          Authorization: `Bearer ${token}`,
        },
      })

      if (!response.ok) {
        throw new Error("Error al obtener los comentarios")
      }

      const data = await response.json()
      setComentarios(data.comentarios)
    } catch (error) {
      console.error("Error:", error)
    }
  }

  // Función para agregar comentario
  const handleAddComentario = async (e) => {
    e.preventDefault()

    if (!nuevoComentario.trim() || !pedidoSeleccionadoId) return

    try {
      const token = localStorage.getItem('token')
      
      const response = await fetch(`${API_URL}/api/pedidos/${pedidoSeleccionadoId}/comentarios-pedido`, {
        method: "POST",
        headers: {
          Authorization: `Bearer ${token}`,
          "Content-Type": "application/json",
        },
        body: JSON.stringify({
          texto: nuevoComentario,
        }),
      })

      if (!response.ok) {
        throw new Error("Error al agregar el comentario")
      }

      const data = await response.json()
      setComentarios(data.comentarios)
      setNuevoComentario("")
    } catch (error) {
      console.error("Error:", error)
    }
  }

  // Función para seleccionar/deseleccionar todos los pedidos
  const handleSelectAllPedidos = (e) => {
    if (e.target.checked) {
      setPedidosSeleccionados(pedidos.map((pedido) => pedido.id))
    } else {
      setPedidosSeleccionados([])
    }
  }

  // Función para seleccionar/deseleccionar un pedido
  const handleSelectPedido = (e, pedidoId) => {
    if (e.target.checked) {
      setPedidosSeleccionados([...pedidosSeleccionados, pedidoId])
    } else {
      setPedidosSeleccionados(pedidosSeleccionados.filter((id) => id !== pedidoId))
    }
  }

  // Función para manejar el cambio de filtros
  const handleSubmitFiltros = (e) => {
    e.preventDefault()
    // Los filtros se actualizan automáticamente a través del useEffect
  }

  // Función para limpiar filtros
  const handleLimpiarFiltros = () => {
    setEstadoFiltro("")
    setFechaDesdeFiltro("")
    setFechaHastaFiltro("")
    setNpedidoFiltro("")
    setClienteFiltro("")
    setProveedorFiltro("")
  }

  // Función para obtener el texto del estado
  const getEstadoText = (estado) => {
    switch (estado) {
      case 1:
        return "Abierto"
      case 2:
        return "En proceso"
      case 3:
        return "Enviado"
      case 4:
        return "Envío parcial"
      case 5:
        return "Cerrado"
      default:
        return "Desconocido"
    }
  }

  // Obtener la clase de color para el estado
  const getEstadoClass = (estado) => {
    switch (estado) {
      case 1:
        return "bg-blue-100 text-blue-800"
      case 2:
        return "bg-yellow-100 text-yellow-800"
      case 3:
        return "bg-green-100 text-green-800"
      case 4:
        return "bg-purple-100 text-purple-800"
      case 5:
        return "bg-gray-100 text-gray-800"
      default:
        return "bg-gray-100 text-gray-800"
    }
  }

  // Formatear fecha
  const formatDate = (dateString) => {
    if (!dateString) return ""
    const date = new Date(dateString)
    return date.toLocaleDateString("es-ES")
  }

  // Formatear moneda
  const formatCurrency = (amount) => {
    return new Intl.NumberFormat("es-ES", {
      style: "currency",
      currency: "EUR",
      minimumFractionDigits: 2,
      maximumFractionDigits: 2,
    }).format(amount)
  }

  // Componente de estado de carga
  if (loading && pedidos.length === 0) {
    return (
      <div className="fixed inset-0 top-16 bg-gradient-to-br from-gray-50 to-gray-100 flex justify-center items-center">
        <div className="text-center">
          <div className="relative mb-8">
            <div className="w-20 h-20 border-4 rounded-full animate-spin border-t-teal-600 mx-auto" style={{borderColor: '#14b8a640', borderTopColor: '#14b8a6'}}></div>
            <FileText className="w-8 h-8 absolute top-1/2 left-1/2 transform -translate-x-1/2 -translate-y-1/2 text-teal-500" />
          </div>
          <h3 className="text-xl font-bold mb-2 text-teal-600">Cargando pedidos</h3>
          <p className="text-gray-600">Obteniendo lista de pedidos...</p>
        </div>
      </div>
    );
  }

  // Sección de error mejorada
  if (error && pedidos.length === 0) {
    return (
      <div className="fixed inset-0 top-16 bg-gradient-to-br from-gray-50 to-gray-100 flex justify-center items-center">
        <div className="bg-red-100 text-red-800 p-6 rounded-xl shadow-lg max-w-lg w-full border border-red-200 mx-4">
          <div className="flex items-start">
            <AlertTriangle size={28} className="text-red-500 mr-4 flex-shrink-0 mt-1" />
            <div>
              <h3 className="font-bold text-lg text-red-700 mb-2">Error de carga</h3>
              <p className="text-red-700">{error}</p>
              <button 
                onClick={() => window.location.reload()}
                className="mt-4 bg-red-600 hover:bg-red-700 text-white py-2 px-4 rounded-md transition-all duration-200 inline-flex items-center"
              >
                <RefreshCw size={16} className="mr-2" />
                Reintentar
              </button>
            </div>
          </div>
        </div>
      </div>
    );
  }

  return (
    <div className="fixed inset-0 top-16 bg-gradient-to-br from-gray-50 to-gray-100 overflow-hidden">
      
      {/* Panel Lateral */}
      <SidePanel
        isOpen={sidePanelOpen}
        setIsOpen={setSidePanelOpen}
        estadoFiltro={estadoFiltro}
        setEstadoFiltro={setEstadoFiltro}
        fechaDesdeFiltro={fechaDesdeFiltro}
        setFechaDesdeFiltro={setFechaDesdeFiltro}
        fechaHastaFiltro={fechaHastaFiltro}
        setFechaHastaFiltro={setFechaHastaFiltro}
        npedidoFiltro={npedidoFiltro}
        setNpedidoFiltro={setNpedidoFiltro}
        clienteFiltro={clienteFiltro}
        setClienteFiltro={setClienteFiltro}
        proveedorFiltro={proveedorFiltro}
        setProveedorFiltro={setProveedorFiltro}
        handleSubmitFiltros={handleSubmitFiltros}
        handleLimpiarFiltros={handleLimpiarFiltros}
        loading={loading}
        proveedores={proveedores}
        user={user}
        pedidosSeleccionados={pedidosSeleccionados}
        estadoMasivo={estadoMasivo}
        setEstadoMasivo={setEstadoMasivo}
        handleActualizarEstados={handleActualizarEstados}
        handleEliminarPedidos={handleEliminarPedidos}
        onAsignarAlbaranMasivo={() => {
          const seleccionados = pedidos.filter(p => pedidosSeleccionados.includes(p.id));
          setAlbaranMasivoModal({ open: true, pedidos: seleccionados });
        }}
        onEliminarAlbaranes={handleEliminarAlbaranesMasivo}
        albaranesSeleccionadosCount={albaranesSeleccionadosCount}
        eliminandoAlbaranes={eliminandoAlbaranes}
        totalPedidos={totalPedidos}
      />

      {/* Área Principal */}
      <div className="h-full flex flex-col" style={{ 
        marginLeft: sidePanelOpen ? '380px' : '0px',
        transition: 'margin-left 0.3s ease-in-out'
      }}>
        
        {/* Header */}
        <div className="flex-shrink-0 bg-white shadow-sm border-b border-gray-200 p-4">
          <div className="flex items-center justify-between">
            <div className="flex items-center">
              <div className="p-2 rounded-lg mr-3" style={{ backgroundColor: 'rgba(20, 184, 166, 0.1)' }}>
                <Package size={20} style={{ color: '#14b8a6' }} />
              </div>
              <div>
                <h1 className="text-lg font-bold text-gray-800">Gestión de Pedidos</h1>
                <p className="text-sm text-gray-600">Control completo de pedidos y estados</p>
              </div>
            </div>
            
            <div className="flex items-center space-x-4">
              {/* NUEVO BOTÓN DE SUBIDA MASIVA */}
              {user && user.permisos !== 5 && (
                <button
                  onClick={() => setShowBulkInvoiceModal(true)}
                  className="bg-gradient-to-r from-green-500 to-green-600 hover:from-green-600 hover:to-green-700 text-white px-4 py-2 rounded-lg transition-all duration-200 inline-flex items-center shadow-md font-medium"
                >
                  <Upload size={18} className="mr-2" />
                  Subir Facturas
                </button>
              )}

              {user && user.permisos !== 5 && (
                <button
                  onClick={() => setShowBulkAlbaranModal(true)}
                  className="text-white px-4 py-2 rounded-lg transition-all duration-200 inline-flex items-center shadow-md font-medium hover:shadow-lg"
                  style={{ backgroundColor: theme.primary }}
                  onMouseEnter={(e) => (e.currentTarget.style.backgroundColor = theme.primaryDark)}
                  onMouseLeave={(e) => (e.currentTarget.style.backgroundColor = theme.primary)}
                >
                  <Upload size={18} className="mr-2" />
                  Subir Albaranes
                </button>
              )}
              
              <div className="text-right">
                <div className="text-sm font-medium text-gray-900">
                  {pedidos.length} pedidos encontrados
                </div>
                <div className="text-xs text-gray-500">
                  Total: {totalPedidos} registros
                </div>
              </div>
            </div>
          </div>
        </div>

        {/* Contenido Principal */}
        <div className="flex-1 overflow-auto">
          <div className="h-full" style={{ 
            paddingLeft: '53px', 
            paddingRight: sidePanelOpen ? '25px' : '16px',
            paddingTop: '24px', 
            paddingBottom: '24px',
            transition: 'padding-right 0.3s ease-in-out'
          }}>

            {pedidos.length > 0 ? (
              <div className="bg-white rounded-xl shadow-lg overflow-hidden border border-gray-100 h-full flex flex-col">
                <div className="flex-1 overflow-auto">
                  <table className="w-full table-auto divide-y divide-gray-200">
                    <thead className="sticky top-0">
                      <tr>
                        {user && user.permisos !== 5 && (
                          <th className="w-12 px-3 py-3 bg-teal-500 text-white text-center text-sm font-semibold">
                            <input
                              type="checkbox"
                              onChange={handleSelectAllPedidos}
                              checked={
                                pedidosSeleccionados.length === pedidos.length && pedidos.length > 0
                              }
                              className="h-4 w-4 accent-teal-700 cursor-pointer"
                            />
                          </th>
                        )}
                        <th className="w-16 px-3 py-3 bg-teal-500 text-white text-left text-sm font-semibold">ID</th>
                        <th className="w-28 px-3 py-3 bg-teal-500 text-white text-left text-sm font-semibold">Estado</th>
                        <th className="px-3 py-3 bg-teal-500 text-white text-left text-sm font-semibold">Cliente</th>
                        <th className="w-32 px-3 py-3 bg-teal-500 text-white text-left text-sm font-semibold">Proveedor</th>
                        <th className="w-24 px-3 py-3 bg-teal-500 text-white text-left text-sm font-semibold">Fecha</th>
                        <th className="w-32 px-3 py-3 bg-teal-500 text-white text-left text-sm font-semibold">Tipo</th>
                        <th className="w-40 px-3 py-3 bg-teal-500 text-white text-left text-sm font-semibold">Comentarios</th>
                        <th className="w-24 px-3 py-3 bg-teal-500 text-white text-left text-sm font-semibold">Total IVA</th>
                        <th className="w-28 px-3 py-3 bg-teal-500 text-white text-left text-sm font-semibold">Albarán</th>
                        <th className="w-24 px-3 py-3 bg-teal-500 text-white text-center text-sm font-semibold">Factura</th>
                        <th className="w-32 px-3 py-3 bg-teal-500 text-white text-center text-sm font-semibold">PDF</th>
                        <th className="w-28 px-3 py-3 bg-teal-500 text-white text-center text-sm font-semibold">Acciones</th>
                      </tr>
                    </thead>
                    <tbody className="divide-y divide-gray-200 bg-white">
                      {pedidos.map((pedido, index) => (
                        <tr
                          key={pedido.id}
                          className={`hover:bg-gray-50 transition-colors ${index % 2 === 0 ? "bg-white" : "bg-gray-50"}`}
                        >
                          {user && user.permisos !== 5 && (
                            <td className="px-3 py-3 text-center">
                              <input
                                type="checkbox"
                                checked={pedidosSeleccionados.includes(pedido.id)}
                                onChange={(e) => handleSelectPedido(e, pedido.id)}
                                className="h-4 w-4 accent-teal-500 cursor-pointer"
                              />
                            </td>
                          )}
                          <td className="px-3 py-3 text-sm font-medium text-gray-900">{pedido.id}</td>
                          <td className="px-3 py-3">
                            <span className={`inline-block px-2 py-1 rounded-full text-xs font-medium ${getEstadoClass(pedido.estado)}`}>
                              {getEstadoText(pedido.estado)}
                            </span>
                          </td>
                          <td className="px-3 py-3 text-sm text-gray-700">{pedido.razon_social}</td>
                          <td className="px-3 py-3 text-sm text-gray-700">{pedido.proveedor_nombre}</td>
                          <td className="px-3 py-3 text-sm text-gray-700">{formatDate(pedido.fecha)}</td>
                          <td className="px-3 py-3">
                            {getTipoBadge(pedido.tipo, pedido.cliente, pedido.clinica_matriz)}
                          </td>
                          <td className="px-3 py-3 text-sm text-gray-700">
                            {pedido.comentarios ? (
                              <div className="overflow-hidden">
                                {pedido.comentarios.length > 45
                                  ? `${pedido.comentarios.substring(0, 45)}...`
                                  : pedido.comentarios}
                              </div>
                            ) : (
                              <span className="text-gray-400 italic text-xs">Sin comentarios</span>
                            )}
                          </td>
                          <td className="px-3 py-3 text-sm font-medium text-gray-900">{formatCurrency(pedido.itotaliva)}</td>
                          <td className="px-3 py-3">
                            {user && user.permisos !== 5 ? (
                              <input
                                type="text"
                                className="w-full px-2 py-1 border border-gray-300 rounded-lg focus:ring-1 focus:ring-teal-500 focus:border-teal-500 transition-colors text-sm"
                                defaultValue={pedido.albaran || ""}
                                placeholder="Nº Albarán"
                                onBlur={(e) => handleUpdateAlbaran(pedido.id, e.target.value)}
                              />
                            ) : (
                              <span className="text-sm text-gray-700">{pedido.albaran || <span className="text-gray-400 italic">Sin albarán</span>}</span>
                            )}
                          </td>
                          <td className="px-3 py-3 text-center">
                            {user && user.permisos !== 5 && (
                              <div className="flex flex-row gap-1 justify-center">
                                {pedido.pdf_factura ? (
                                  <>
                                    <button
                                      onClick={() => viewInvoice(pedido.id)}
                                      className="text-blue-600 hover:text-blue-900 p-1 rounded transition-colors duration-200"
                                      title="Ver factura"
                                    >
                                      <Eye className="w-4 h-4" />
                                    </button>
                                    <button
                                      onClick={() => openInvoiceModal(pedido)}
                                      className="text-orange-600 hover:text-orange-900 p-1 rounded transition-colors duration-200"
                                      title="Modificar factura"
                                    >
                                      <Edit className="w-4 h-4" />
                                    </button>
                                    <button
                                      onClick={() => deleteInvoice(pedido.id)}
                                      className="text-red-600 hover:text-red-900 p-1 rounded transition-colors duration-200"
                                      title="Eliminar factura"
                                    >
                                      <Trash2 className="w-4 h-4" />
                                    </button>
                                  </>
                                ) : [3, 4, 5].includes(pedido.estado) ? (
                                  <button
                                    onClick={() => openInvoiceModal(pedido)}
                                    className="text-green-600 hover:text-green-900 p-1 rounded transition-colors duration-200"
                                    title="Subir factura"
                                  >
                                    <Upload className="w-4 h-4" />
                                  </button>
                                ) : (
                                  <span className="text-gray-400 text-xs">—</span>
                                )}
                              </div>
                            )}
                          </td>
                          <td className="px-3 py-3">
                            <div className="flex flex-col gap-1">
                              <button
                                onClick={() => handleDescargarPDF(pedido.id)}
                                disabled={loadingPdf}
                                className={`${
                                  loadingPdf ? 'bg-red-400' : 'bg-red-500 hover:bg-red-600'
                                } text-white px-2 py-1 rounded-lg inline-flex items-center justify-center transition-colors shadow-sm text-xs font-medium whitespace-nowrap`}
                              >
                                {loadingPdf ? (
                                  <>
                                    <span className="animate-spin h-3 w-3 mr-1 border-t-2 border-b-2 border-white rounded-full"></span>
                                    Gen...
                                  </>
                                ) : (
                                  <>
                                    <FileText size={13} className="mr-1" />
                                    PDF
                                  </>
                                )}
                              </button>
                              {user && user.permisos !== 5 && (() => {
                                const albs = albaranesPorPedido[pedido.id] || []
                                const tieneAlbaran = albs.length > 0
                                return (
                                  <>
                                    <button
                                      onClick={() => openAlbaranModal(pedido)}
                                      className="text-white px-2 py-1 rounded-lg inline-flex items-center justify-center transition-colors shadow-sm text-xs font-medium whitespace-nowrap"
                                      style={{ backgroundColor: theme.primary }}
                                      onMouseEnter={(e) => (e.currentTarget.style.backgroundColor = theme.primaryDark)}
                                      onMouseLeave={(e) => (e.currentTarget.style.backgroundColor = theme.primary)}
                                      title="Subir el PDF del albarán"
                                    >
                                      <Upload size={13} className="mr-1" />
                                      {tieneAlbaran ? 'Subir otro' : 'Subir albarán'}
                                    </button>
                                    {tieneAlbaran && (
                                      <a
                                        href={`${API_URL}${albs[0].url}`}
                                        target="_blank"
                                        rel="noopener noreferrer"
                                        title={`Ver albarán subido${albs.length > 1 ? ` (${albs.length})` : ''}`}
                                        className="inline-flex items-center justify-center gap-1 text-[11px] font-medium text-green-700 bg-green-50 hover:bg-green-100 border border-green-200 rounded-lg px-2 py-1 transition-colors whitespace-nowrap"
                                      >
                                        <CheckCircle size={12} />
                                        {albs.length > 1 ? `${albs.length} albaranes` : 'Albarán subido'}
                                      </a>
                                    )}
                                  </>
                                )
                              })()}
                            </div>
                          </td>
                          <td className="px-3 py-3">
                            <div className="flex flex-col gap-1">
                              <button
                                type="button"
                                onClick={() => handleShowComentarios(pedido.id)}
                                className="bg-teal-500 hover:bg-teal-600 text-white px-2 py-1 rounded-lg inline-flex items-center justify-center transition-colors shadow-sm text-xs font-medium"
                              >
                                <MessageCircle size={13} className="mr-1" />
                                Com.
                              </button>
                              <Link
                                to={`/pedidos/detalles/${pedido.id}`}
                                className="bg-blue-500 hover:bg-blue-600 text-white px-2 py-1 rounded-lg inline-flex items-center justify-center transition-colors shadow-sm text-xs font-medium"
                              >
                                <FileText size={13} className="mr-1" />
                                Det.
                              </Link>
                            </div>
                          </td>
                        </tr>
                      ))}
                    </tbody>
                  </table>
                </div>
              </div>
            ) : (
              <div className="bg-white p-10 rounded-xl text-center border border-yellow-200 shadow-md">
                <div className="flex flex-col items-center justify-center">
                  <div className="bg-yellow-100 p-4 rounded-full mb-4">
                    <AlertTriangle size={40} className="text-yellow-500" />
                  </div>
                  <h3 className="text-xl font-medium text-gray-800 mb-2">No hay pedidos para mostrar</h3>
                  <p className="text-gray-600 max-w-lg mx-auto mb-6">
                    Modifica los filtros de búsqueda o crea nuevos pedidos.
                  </p>
                  <button 
                    onClick={() => window.location.reload()}
                    className="bg-teal-600 hover:bg-teal-700 text-white py-2 px-6 rounded-lg transition-colors inline-flex items-center shadow-sm"
                  >
                    <RefreshCw size={16} className="mr-2" />
                    Actualizar datos
                  </button>
                </div>
              </div>
            )}
          </div>
        </div>
      </div>

      {/* Modal de comentarios */}
      {comentariosModalVisible && (
        <div className="fixed inset-0 bg-black bg-opacity-60 backdrop-blur-sm flex items-center justify-center z-50 px-4">
          <div
            className="bg-white rounded-xl shadow-2xl w-full max-w-2xl max-h-[80vh] overflow-hidden"
            ref={comentariosModalRef}
          >
            <div className="bg-gradient-to-r from-teal-600 to-teal-500 p-6">
              <div className="flex justify-between items-center">
                <h3 className="text-xl font-bold text-white">Comentarios del Pedido #{pedidoSeleccionadoId}</h3>
                <button
                  onClick={() => setComentariosModalVisible(false)}
                  className="text-white hover:bg-teal-600 p-2 rounded-full transition-colors"
                >
                  <X size={20} />
                </button>
              </div>
            </div>

            <div className="p-6">
              <div className="max-h-96 overflow-y-auto bg-gray-50 rounded-xl p-4 mb-6">
                {comentarios.length > 0 ? (
                  comentarios.map((comentario) => (
                    <div 
                      key={comentario.id} 
                      className="bg-white mb-4 p-4 rounded-lg shadow-sm hover:shadow transition-shadow border border-gray-100"
                    >
                      <div className="font-semibold text-teal-700 mb-2">{comentario.username}</div>
                      <div className="text-gray-700 mb-3 whitespace-pre-wrap leading-relaxed">{comentario.texto}</div>
                      <div className="text-xs text-gray-500 flex items-center">
                        <span>{formatDate(comentario.fecha)}</span>
                        <span className="mx-2">•</span>
                        <span>{new Date(comentario.fecha).toLocaleTimeString()}</span>
                      </div>
                    </div>
                  ))
                ) : (
                  <div className="py-12 text-center">
                    <div className="bg-gray-100 p-4 rounded-full mb-4 w-16 h-16 mx-auto flex items-center justify-center">
                      <MessageCircle size={24} className="text-gray-400" />
                    </div>
                    <p className="text-gray-500 font-medium mb-2">No hay comentarios para este pedido</p>
                    <p className="text-sm text-gray-400">Sé el primero en dejar un comentario</p>
                  </div>
                )}
              </div>

              <form onSubmit={handleAddComentario}>
                <div className="mb-4">
                  <label className="block text-sm font-medium text-gray-700 mb-2">Nuevo comentario</label>
                  <textarea
                    className="w-full p-4 border border-gray-300 rounded-xl focus:ring-2 focus:ring-teal-500 focus:border-teal-500 transition-colors resize-none"
                    rows="4"
                    placeholder="Escribe tu comentario aquí..."
                    value={nuevoComentario}
                    onChange={(e) => setNuevoComentario(e.target.value)}
                  ></textarea>
                </div>

                <button
                  type="submit"
                  className={`w-full py-3 px-4 rounded-xl transition-colors shadow-md flex items-center justify-center font-medium ${
                    !nuevoComentario.trim()
                      ? "bg-gray-300 text-gray-500 cursor-not-allowed"
                      : "bg-teal-500 hover:bg-teal-600 text-white focus:outline-none focus:ring-2 focus:ring-teal-500 focus:ring-offset-2"
                  }`}
                  disabled={!nuevoComentario.trim()}
                >
                  <MessageCircle size={18} className="mr-2" />
                  Enviar Comentario
                </button>
              </form>
            </div>
          </div>
        </div>
      )}

      {/* NUEVO MODAL DE SUBIDA MASIVA DE FACTURAS */}
      {showBulkInvoiceModal && (
        <div className="fixed inset-0 bg-black bg-opacity-60 backdrop-blur-sm flex items-center justify-center z-50 px-4">
          <div className="bg-white rounded-xl shadow-2xl w-full max-w-3xl max-h-[85vh] overflow-hidden flex flex-col">
            <div className="bg-gradient-to-r from-green-600 to-green-500 p-6 flex-shrink-0">
              <div className="flex justify-between items-center">
                <h3 className="text-xl font-bold text-white">Subida Masiva de Facturas</h3>
                <button
                  onClick={() => {
                    if (!uploadingBulkInvoices) {
                      setShowBulkInvoiceModal(false);
                      clearBulkInvoiceFiles();
                    }
                  }}
                  disabled={uploadingBulkInvoices}
                  className="text-white hover:bg-green-600 p-2 rounded-full transition-colors disabled:opacity-50 disabled:cursor-not-allowed"
                >
                  <X size={20} />
                </button>
              </div>
            </div>

            <div className="flex-1 overflow-y-auto p-6">
              {/* Instrucciones */}
              <div className="mb-6 p-4 bg-blue-50 border border-blue-200 rounded-lg">
                <div className="flex items-start">
                  <AlertTriangle size={20} className="text-blue-600 mr-3 flex-shrink-0 mt-0.5" />
                  <div>
                    <p className="text-sm text-blue-800 font-medium mb-2">
                      Instrucciones para la subida masiva:
                    </p>
                    <ul className="text-xs text-blue-700 space-y-1 list-disc list-inside">
                      <li>Los archivos PDF deben incluir el <strong>número de pedido</strong> en el nombre</li>
                      <li>Ejemplos: <code className="bg-blue-100 px-1 rounded">12345.pdf</code>, <code className="bg-blue-100 px-1 rounded">pedido_12345.pdf</code>, <code className="bg-blue-100 px-1 rounded">12345_factura.pdf</code></li>
                      <li>Solo se aceptan archivos PDF de hasta 50MB</li>
                      <li>Solo se subirán facturas a pedidos con estado: Enviado, Envío parcial o Cerrado</li>
                      <li>Si un pedido ya tiene factura, será reemplazada</li>
                    </ul>
                  </div>
                </div>
              </div>

              {/* Selector de archivos */}
              <div className="mb-6">
                <label className="block text-sm font-medium text-gray-700 mb-3">
                  Seleccionar archivos PDF
                </label>
                <div className="border-2 border-dashed border-gray-300 rounded-lg p-6 text-center hover:border-green-500 transition-colors">
                  <input
                    type="file"
                    accept="application/pdf"
                    multiple
                    onChange={handleBulkInvoiceFilesChange}
                    disabled={uploadingBulkInvoices}
                    className="hidden"
                    id="bulk-invoice-input"
                  />
                  <label
                    htmlFor="bulk-invoice-input"
                    className={`cursor-pointer ${uploadingBulkInvoices ? 'opacity-50 cursor-not-allowed' : ''}`}
                  >
                    <Upload size={40} className="mx-auto text-gray-400 mb-2" />
                    <p className="text-sm text-gray-600 font-medium mb-1">
                      Haz clic para seleccionar archivos
                    </p>
                    <p className="text-xs text-gray-500">
                      o arrastra y suelta archivos PDF aquí
                    </p>
                  </label>
                </div>
              </div>

              {/* Lista de archivos seleccionados */}
              {bulkInvoiceFiles.length > 0 && !bulkUploadResults && (
                <div className="mb-6">
                  <div className="flex justify-between items-center mb-3">
                    <h4 className="text-sm font-medium text-gray-700">
                      Archivos seleccionados ({bulkInvoiceFiles.length})
                    </h4>
                    <button
                      onClick={clearBulkInvoiceFiles}
                      disabled={uploadingBulkInvoices}
                      className="text-xs text-red-600 hover:text-red-800 transition-colors disabled:opacity-50"
                    >
                      Limpiar todos
                    </button>
                  </div>
                  <div className="max-h-60 overflow-y-auto border border-gray-200 rounded-lg">
                    {bulkInvoiceFiles.map((file, index) => (
                      <div
                        key={index}
                        className="flex items-center justify-between p-3 hover:bg-gray-50 border-b border-gray-100 last:border-b-0"
                      >
                        <div className="flex items-center flex-1 min-w-0">
                          <FileText size={18} className="text-red-500 mr-3 flex-shrink-0" />
                          <div className="flex-1 min-w-0">
                            <p className="text-sm font-medium text-gray-900 truncate">
                              {file.name}
                            </p>
                            <p className="text-xs text-gray-500">
                              {(file.size / 1024 / 1024).toFixed(2)} MB
                            </p>
                          </div>
                        </div>
                        <button
                          onClick={() => removeBulkInvoiceFile(index)}
                          disabled={uploadingBulkInvoices}
                          className="text-red-600 hover:text-red-800 p-1 ml-2 transition-colors disabled:opacity-50"
                        >
                          <X size={18} />
                        </button>
                      </div>
                    ))}
                  </div>
                </div>
              )}

              {/* Resultados de la subida */}
              {bulkUploadResults && (
                <div className="mb-6">
                  <div className={`p-4 rounded-lg border ${
                    bulkUploadResults.failed === 0 
                      ? 'bg-green-50 border-green-200' 
                      : 'bg-yellow-50 border-yellow-200'
                  }`}>
                    <div className="flex items-start">
                      <CheckCircle 
                        size={24} 
                        className={`mr-3 flex-shrink-0 ${
                          bulkUploadResults.failed === 0 ? 'text-green-600' : 'text-yellow-600'
                        }`} 
                      />
                      <div className="flex-1">
                        <h4 className={`font-semibold mb-2 ${
                          bulkUploadResults.failed === 0 ? 'text-green-800' : 'text-yellow-800'
                        }`}>
                          Resultados de la subida
                        </h4>
                        <p className={`text-sm mb-3 ${
                          bulkUploadResults.failed === 0 ? 'text-green-700' : 'text-yellow-700'
                        }`}>
                          <strong>{bulkUploadResults.uploaded}</strong> de <strong>{bulkUploadResults.total}</strong> facturas subidas correctamente
                        </p>
                        
                        {/* Facturas subidas correctamente */}
                        {bulkUploadResults.successDetails.length > 0 && (
                          <div className="mb-3">
                            <p className="text-xs font-medium text-green-800 mb-2">
                              ✓ Subidas correctamente:
                            </p>
                            <div className="max-h-32 overflow-y-auto bg-white rounded border border-green-200 p-2">
                              {bulkUploadResults.successDetails.map((success, index) => (
                                <div key={index} className="text-xs text-green-700 py-1">
                                  • {success.filename} → Pedido #{success.npedido}
                                </div>
                              ))}
                            </div>
                          </div>
                        )}

                        {/* Errores */}
                        {bulkUploadResults.errors.length > 0 && (
                          <div>
                            <p className="text-xs font-medium text-red-800 mb-2">
                              ✗ Errores ({bulkUploadResults.errors.length}):
                            </p>
                            <div className="max-h-40 overflow-y-auto bg-white rounded border border-red-200 p-2">
                              {bulkUploadResults.errors.map((error, index) => (
                                <div key={index} className="text-xs text-red-700 py-1 border-b border-red-100 last:border-b-0">
                                  <strong>{error.filename}</strong>
                                  {error.npedido && <span> (Pedido #{error.npedido})</span>}
                                  <br />
                                  <span className="text-red-600">→ {error.error}</span>
                                </div>
                              ))}
                            </div>
                          </div>
                        )}

                        {bulkUploadResults.failed === 0 && (
                          <p className="text-xs text-green-600 mt-3">
                            La página se recargará automáticamente...
                          </p>
                        )}
                      </div>
                    </div>
                  </div>
                </div>
              )}
            </div>

            {/* Botones de acción */}
            <div className="flex-shrink-0 p-6 border-t border-gray-200 bg-gray-50">
              <div className="flex space-x-3">
                <button
                  onClick={() => {
                    if (bulkUploadResults && bulkUploadResults.uploaded > 0) {
                      window.location.reload();
                    } else {
                      setShowBulkInvoiceModal(false);
                      clearBulkInvoiceFiles();
                    }
                  }}
                  disabled={uploadingBulkInvoices}
                  className="flex-1 px-4 py-3 border border-gray-300 text-gray-700 rounded-lg hover:bg-gray-100 transition-colors disabled:opacity-50 disabled:cursor-not-allowed font-medium"
                >
                  {bulkUploadResults && bulkUploadResults.uploaded > 0 ? 'Cerrar y Recargar' : 'Cancelar'}
                </button>
                {!bulkUploadResults && (
                  <button
                    onClick={uploadBulkInvoices}
                    disabled={bulkInvoiceFiles.length === 0 || uploadingBulkInvoices}
                    className={`flex-1 px-4 py-3 rounded-lg transition-colors flex items-center justify-center font-medium ${
                      bulkInvoiceFiles.length === 0 || uploadingBulkInvoices
                        ? 'bg-gray-300 text-gray-500 cursor-not-allowed'
                        : 'bg-green-600 hover:bg-green-700 text-white'
                    }`}
                  >
                    {uploadingBulkInvoices ? (
                      <>
                        <Loader size={18} className="mr-2 animate-spin" />
                        Subiendo {bulkInvoiceFiles.length} factura{bulkInvoiceFiles.length !== 1 ? 's' : ''}...
                      </>
                    ) : (
                      <>
                        <Upload size={18} className="mr-2" />
                        Subir {bulkInvoiceFiles.length} factura{bulkInvoiceFiles.length !== 1 ? 's' : ''}
                      </>
                    )}
                  </button>
                )}
              </div>
            </div>
          </div>
        </div>
      )}

      {/* MODAL DE CARGA MASIVA DE ALBARANES */}
      {showBulkAlbaranModal && (
        <div className="fixed inset-0 bg-black bg-opacity-60 backdrop-blur-sm flex items-center justify-center z-50 px-4">
          <div className="bg-white rounded-xl shadow-2xl w-full max-w-3xl overflow-hidden flex flex-col" style={{ maxHeight: "85vh" }}>
            <div className="p-6 flex-shrink-0" style={{ backgroundColor: theme.primary }}>
              <div className="flex justify-between items-center">
                <h3 className="text-xl font-bold text-white">Subida masiva de albaranes</h3>
                <button
                  onClick={() => { if (!uploadingBulkAlbaranes) { setShowBulkAlbaranModal(false); clearBulkAlbaranFiles(); } }}
                  disabled={uploadingBulkAlbaranes}
                  className="text-white hover:bg-white/20 p-2 rounded-full transition-colors disabled:opacity-50"
                >
                  <X size={20} />
                </button>
              </div>
            </div>

            <div className="flex-1 overflow-y-auto p-6" style={{ minHeight: 0 }}>
              {/* Instrucciones */}
              <div className="mb-6 p-4 bg-blue-50 border border-blue-200 rounded-lg">
                <div className="flex items-start">
                  <AlertTriangle size={20} className="text-blue-600 mr-3 flex-shrink-0 mt-0.5" />
                  <div>
                    <p className="text-sm text-blue-800 font-medium mb-2">¿Cómo funciona?</p>
                    <ul className="text-xs text-blue-700 space-y-1 list-disc list-inside">
                      <li>El nombre de cada PDF debe contener el <strong>nº de pedido</strong></li>
                      <li>Ejemplos: <code className="bg-blue-100 px-1 rounded">56510.pdf</code>, <code className="bg-blue-100 px-1 rounded">albaran_56510.pdf</code>, <code className="bg-blue-100 px-1 rounded">56510 (1).pdf</code></li>
                      <li>El albarán se asocia <strong>automáticamente</strong> al pedido que coincida</li>
                      <li>Solo PDFs de hasta 50MB</li>
                    </ul>
                  </div>
                </div>
              </div>

              {/* Selector de archivos */}
              <div className="mb-6">
                <label className="block text-sm font-medium text-gray-700 mb-3">Seleccionar archivos PDF</label>
                <div className="border-2 border-dashed border-gray-300 rounded-lg p-6 text-center hover:border-gray-400 transition-colors">
                  <input
                    type="file"
                    accept="application/pdf"
                    multiple
                    onChange={handleBulkAlbaranFilesChange}
                    disabled={uploadingBulkAlbaranes}
                    className="hidden"
                    id="bulk-albaran-input"
                  />
                  <label htmlFor="bulk-albaran-input" className={`cursor-pointer ${uploadingBulkAlbaranes ? 'opacity-50 cursor-not-allowed' : ''}`}>
                    <Upload size={40} className="mx-auto text-gray-400 mb-2" />
                    <p className="text-sm text-gray-600 font-medium mb-1">Haz clic para seleccionar archivos</p>
                    <p className="text-xs text-gray-500">o arrastra y suelta los PDFs aquí</p>
                  </label>
                </div>
              </div>

              {/* Lista de archivos */}
              {bulkAlbaranFiles.length > 0 && !bulkAlbaranResults && (
                <div className="mb-6">
                  <div className="flex justify-between items-center mb-3">
                    <h4 className="text-sm font-medium text-gray-700">Archivos seleccionados ({bulkAlbaranFiles.length})</h4>
                    <button onClick={clearBulkAlbaranFiles} disabled={uploadingBulkAlbaranes} className="text-xs text-red-600 hover:text-red-800 transition-colors disabled:opacity-50">
                      Limpiar todos
                    </button>
                  </div>
                  <div className="max-h-60 overflow-y-auto border border-gray-200 rounded-lg">
                    {bulkAlbaranFiles.map((file, index) => (
                      <div key={index} className="flex items-center justify-between p-3 hover:bg-gray-50 border-b border-gray-100 last:border-b-0">
                        <div className="flex items-center flex-1 min-w-0">
                          <FileText size={18} className="text-red-500 mr-3 flex-shrink-0" />
                          <div className="flex-1 min-w-0">
                            <p className="text-sm font-medium text-gray-900 truncate">{file.name}</p>
                            <p className="text-xs text-gray-500">{(file.size / 1024 / 1024).toFixed(2)} MB</p>
                          </div>
                        </div>
                        <button onClick={() => removeBulkAlbaranFile(index)} disabled={uploadingBulkAlbaranes} className="text-red-600 hover:text-red-800 p-1 ml-2 transition-colors disabled:opacity-50">
                          <X size={18} />
                        </button>
                      </div>
                    ))}
                  </div>
                </div>
              )}

              {/* Resultados */}
              {bulkAlbaranResults && (
                <div className="mb-2">
                  <div className={`p-4 rounded-lg border ${bulkAlbaranResults.failed === 0 ? 'bg-green-50 border-green-200' : 'bg-yellow-50 border-yellow-200'}`}>
                    <div className="flex items-start">
                      <CheckCircle size={24} className={`mr-3 flex-shrink-0 ${bulkAlbaranResults.failed === 0 ? 'text-green-600' : 'text-yellow-600'}`} />
                      <div className="flex-1">
                        <h4 className={`font-semibold mb-2 ${bulkAlbaranResults.failed === 0 ? 'text-green-800' : 'text-yellow-800'}`}>Resultado de la carga</h4>
                        <p className={`text-sm mb-3 ${bulkAlbaranResults.failed === 0 ? 'text-green-700' : 'text-yellow-700'}`}>
                          <strong>{bulkAlbaranResults.uploaded}</strong> de <strong>{bulkAlbaranResults.total}</strong> albaranes asociados correctamente
                        </p>
                        {bulkAlbaranResults.successDetails && bulkAlbaranResults.successDetails.length > 0 && (
                          <div className="mb-3">
                            <p className="text-xs font-medium text-green-800 mb-2">✓ Asociados:</p>
                            <div className="max-h-32 overflow-y-auto bg-white rounded border border-green-200 p-2">
                              {bulkAlbaranResults.successDetails.map((s, i) => (
                                <div key={i} className="text-xs text-green-700 py-1">• {s.filename} → Pedido {s.numero}</div>
                              ))}
                            </div>
                          </div>
                        )}
                        {bulkAlbaranResults.errors && bulkAlbaranResults.errors.length > 0 && (
                          <div>
                            <p className="text-xs font-medium text-red-800 mb-2">✗ Sin asociar ({bulkAlbaranResults.errors.length}):</p>
                            <div className="max-h-40 overflow-y-auto bg-white rounded border border-red-200 p-2">
                              {bulkAlbaranResults.errors.map((er, i) => (
                                <div key={i} className="text-xs text-red-700 py-1 border-b border-red-100 last:border-b-0">
                                  <strong>{er.filename}</strong>: {er.error}
                                </div>
                              ))}
                            </div>
                          </div>
                        )}
                        {bulkAlbaranResults.failed === 0 && (
                          <p className="text-xs text-green-600 mt-3">La página se recargará automáticamente...</p>
                        )}
                      </div>
                    </div>
                  </div>
                </div>
              )}
            </div>

            {/* Botones */}
            <div className="flex-shrink-0 p-6 border-t border-gray-200 bg-gray-50">
              <div className="flex space-x-3">
                <button
                  onClick={() => {
                    if (bulkAlbaranResults && bulkAlbaranResults.uploaded > 0) window.location.reload();
                    else { setShowBulkAlbaranModal(false); clearBulkAlbaranFiles(); }
                  }}
                  disabled={uploadingBulkAlbaranes}
                  className="flex-1 px-4 py-3 border border-gray-300 text-gray-700 rounded-lg hover:bg-gray-100 transition-colors disabled:opacity-50 font-medium"
                >
                  {bulkAlbaranResults && bulkAlbaranResults.uploaded > 0 ? 'Cerrar y recargar' : 'Cancelar'}
                </button>
                {!bulkAlbaranResults && (
                  <button
                    onClick={uploadBulkAlbaranes}
                    disabled={bulkAlbaranFiles.length === 0 || uploadingBulkAlbaranes}
                    className="flex-1 px-4 py-3 rounded-lg transition-colors flex items-center justify-center font-medium text-white disabled:bg-gray-300 disabled:text-gray-500 disabled:cursor-not-allowed"
                    style={bulkAlbaranFiles.length === 0 || uploadingBulkAlbaranes ? {} : { backgroundColor: theme.primary }}
                  >
                    {uploadingBulkAlbaranes ? (
                      <><Loader size={18} className="mr-2 animate-spin" /> Subiendo {bulkAlbaranFiles.length}...</>
                    ) : (
                      <><Upload size={18} className="mr-2" /> Subir {bulkAlbaranFiles.length} albar{bulkAlbaranFiles.length === 1 ? 'án' : 'anes'}</>
                    )}
                  </button>
                )}
              </div>
            </div>
          </div>
        </div>
      )}

      {/* Modal de factura individual */}
      {showInvoiceModal && selectedPedidoForInvoice && (
        <div className="fixed inset-0 bg-black bg-opacity-60 backdrop-blur-sm flex items-center justify-center z-50 px-4">
          <div className="bg-white rounded-xl shadow-2xl w-full max-w-lg overflow-hidden">
            <div className="bg-gradient-to-r from-green-600 to-green-500 p-6">
              <div className="flex justify-between items-center">
                <h3 className="text-xl font-bold text-white">
                  {selectedPedidoForInvoice.pdf_factura ? 'Modificar Factura' : 'Subir Factura'}
                </h3>
                <button
                  onClick={() => {
                    setShowInvoiceModal(false);
                    setInvoiceFile(null);
                    setSelectedPedidoForInvoice(null);
                  }}
                  className="text-white hover:bg-green-600 p-2 rounded-full transition-colors"
                >
                  <X size={20} />
                </button>
              </div>
            </div>

            <div className="p-6">
              <div className="mb-4">
                <p className="text-gray-700 mb-2">
                  <strong>Pedido:</strong> #{selectedPedidoForInvoice.id}
                </p>
                <p className="text-gray-700 mb-2">
                  <strong>Cliente:</strong> {selectedPedidoForInvoice.razon_social}
                </p>
                <p className="text-gray-700 mb-4">
                  <strong>Total:</strong> {formatCurrency(selectedPedidoForInvoice.itotaliva)}
                </p>
              </div>

              {selectedPedidoForInvoice.pdf_factura && (
                <div className="mb-6 p-4 bg-yellow-50 border border-yellow-200 rounded-lg">
                  <div className="flex items-start">
                    <AlertTriangle size={20} className="text-yellow-600 mr-2 flex-shrink-0 mt-0.5" />
                    <div>
                      <p className="text-sm text-yellow-800 font-medium mb-1">
                        Ya existe una factura para este pedido
                      </p>
                      <p className="text-xs text-yellow-700">
                        Al subir un nuevo archivo, se reemplazará la factura actual.
                      </p>
                    </div>
                  </div>
                </div>
              )}

              <div className="mb-6">
                <label className="block text-sm font-medium text-gray-700 mb-2">
                  Seleccionar archivo PDF <span className="text-red-500">*</span>
                </label>
                <input
                  type="file"
                  accept="application/pdf"
                  onChange={handleInvoiceFileChange}
                  className="w-full text-sm text-gray-500 file:mr-4 file:py-2 file:px-4 file:rounded-lg file:border-0 file:text-sm file:font-semibold file:bg-green-50 file:text-green-700 hover:file:bg-green-100"
                />
                {invoiceFile && (
                  <p className="mt-2 text-sm text-green-600">
                    ✓ Archivo seleccionado: {invoiceFile.name}
                  </p>
                )}
              </div>

              <div className="flex space-x-3">
                <button
                  onClick={() => {
                    setShowInvoiceModal(false);
                    setInvoiceFile(null);
                    setSelectedPedidoForInvoice(null);
                  }}
                  className="flex-1 px-4 py-2 border border-gray-300 text-gray-700 rounded-lg hover:bg-gray-50 transition-colors"
                >
                  Cancelar
                </button>
                <button
                  onClick={uploadInvoice}
                  disabled={!invoiceFile || uploadingInvoice}
                  className={`flex-1 px-4 py-2 rounded-lg transition-colors flex items-center justify-center ${
                    !invoiceFile || uploadingInvoice
                      ? 'bg-gray-300 text-gray-500 cursor-not-allowed'
                      : 'bg-green-600 hover:bg-green-700 text-white'
                  }`}
                >
                  {uploadingInvoice ? (
                    <>
                      <Loader size={18} className="mr-2 animate-spin" />
                      Subiendo...
                    </>
                  ) : (
                    <>
                      <Upload size={18} className="mr-2" />
                      {selectedPedidoForInvoice.pdf_factura ? 'Reemplazar' : 'Subir'} Factura
                    </>
                  )}
                </button>
              </div>
            </div>
          </div>
        </div>
      )}

      {/* MODAL: Subir PDF del albarán */}
      {showAlbaranModal && selectedPedidoForAlbaran && (
        <div className="fixed inset-0 bg-black bg-opacity-60 backdrop-blur-sm flex items-center justify-center z-50 px-4">
          <div className="bg-white rounded-xl shadow-2xl w-full max-w-lg overflow-hidden">
            <div className="p-6" style={{ backgroundColor: theme.primary }}>
              <div className="flex justify-between items-center">
                <h3 className="text-xl font-bold text-white">Subir albarán (PDF)</h3>
                <button
                  onClick={() => {
                    setShowAlbaranModal(false);
                    setAlbaranFile(null);
                    setAlbaranFechaEntrega('');
                    setSelectedPedidoForAlbaran(null);
                  }}
                  className="text-white hover:bg-white/20 p-2 rounded-full transition-colors"
                >
                  <X size={20} />
                </button>
              </div>
            </div>

            <div className="p-6">
              <div className="mb-4">
                <p className="text-gray-700 mb-2">
                  <strong>Pedido:</strong> #{selectedPedidoForAlbaran.id}
                </p>
                <p className="text-gray-700 mb-2">
                  <strong>Cliente:</strong> {selectedPedidoForAlbaran.razon_social}
                </p>
              </div>

              <div className="mb-6">
                <label className="block text-sm font-medium text-gray-700 mb-2">
                  Seleccionar archivo PDF <span className="text-red-500">*</span>
                </label>
                <input
                  type="file"
                  accept="application/pdf"
                  onChange={handleAlbaranFileChange}
                  className="w-full text-sm text-gray-500 file:mr-4 file:py-2 file:px-4 file:rounded-lg file:border-0 file:text-sm file:font-semibold file:bg-teal-50 file:text-teal-700 hover:file:bg-teal-100"
                />
                {albaranFile && (
                  <p className="mt-2 text-sm font-medium" style={{ color: theme.primaryDark }}>
                    ✓ Archivo seleccionado: {albaranFile.name}
                  </p>
                )}
              </div>

              <div className="mb-6">
                <label className="block text-sm font-medium text-gray-700 mb-2">
                  Fecha de entrega
                </label>
                <input
                  type="date"
                  value={albaranFechaEntrega}
                  onChange={(e) => setAlbaranFechaEntrega(e.target.value)}
                  className="w-full px-3 py-2 border border-gray-300 rounded-lg text-sm focus:outline-none focus:ring-2 focus:border-transparent"
                  onFocus={(e) => (e.target.style.boxShadow = `0 0 0 2px ${theme.primary}`)}
                  onBlur={(e) => (e.target.style.boxShadow = 'none')}
                />
              </div>

              <div className="flex space-x-3">
                <button
                  onClick={() => {
                    setShowAlbaranModal(false);
                    setAlbaranFile(null);
                    setAlbaranFechaEntrega('');
                    setSelectedPedidoForAlbaran(null);
                  }}
                  className="flex-1 px-4 py-2 border border-gray-300 text-gray-700 rounded-lg hover:bg-gray-50 transition-colors"
                >
                  Cancelar
                </button>
                <button
                  onClick={uploadAlbaranPdf}
                  disabled={!albaranFile || uploadingAlbaran}
                  className="flex-1 px-4 py-2 rounded-lg transition-colors flex items-center justify-center text-white disabled:bg-gray-300 disabled:text-gray-500 disabled:cursor-not-allowed"
                  style={!albaranFile || uploadingAlbaran ? {} : { backgroundColor: theme.primary }}
                  onMouseEnter={(e) => { if (!e.currentTarget.disabled) e.currentTarget.style.backgroundColor = theme.primaryDark; }}
                  onMouseLeave={(e) => { if (!e.currentTarget.disabled) e.currentTarget.style.backgroundColor = theme.primary; }}
                >
                  {uploadingAlbaran ? (
                    <>
                      <Loader size={18} className="mr-2 animate-spin" />
                      Subiendo...
                    </>
                  ) : (
                    <>
                      <Upload size={18} className="mr-2" />
                      Subir albarán
                    </>
                  )}
                </button>
              </div>
            </div>
          </div>
        </div>
      )}

      <AlbaranStockModal
        open={albaranModal.open}
        data={albaranModal.data}
        onClose={() => setAlbaranModal({ open: false, pedidoId: null, data: null })}
        onApplied={() => setAlbaranModal({ open: false, pedidoId: null, data: null })}
      />

      <AlbaranMixtoCrearModal
        open={mixtoModal.open}
        pedidoId={mixtoModal.pedidoId}
        albaranNumero={mixtoModal.albaranNumero}
        onClose={() => setMixtoModal({ open: false, pedidoId: null, albaranNumero: "" })}
        onCreated={() => setMixtoModal({ open: false, pedidoId: null, albaranNumero: "" })}
      />

      <AlbaranMasivoModal
        open={albaranMasivoModal.open}
        pedidos={albaranMasivoModal.pedidos}
        onClose={() => setAlbaranMasivoModal({ open: false, pedidos: [] })}
        onApplied={({ ok = [] } = {}) => {
          // El modal muestra una pantalla de resumen tras procesar (no se cierra
          // automáticamente). Actualizamos en local el `albaran` de los pedidos
          // OK para que el listado refleje el cambio sin recargar la página.
          if (ok.length > 0) {
            const mapaNuevoAlbaran = new Map(ok.map(o => [o.pedido.id, o.albaran]));
            setPedidos(prev => prev.map(p =>
              mapaNuevoAlbaran.has(p.id) ? { ...p, albaran: mapaNuevoAlbaran.get(p.id) } : p
            ));
            setPedidosSeleccionados([]);
          }
        }}
      />
    </div>
  )
}

// ─── Modal de verificacion de albaran → stock ─────────────────────────────────
const AlbaranStockModal = ({ open, data, onClose, onApplied }) => {
  const { theme: themeCtx } = useTheme()
  const theme = {
    primary:       themeCtx?.primary       || '#3cbf9a',
    primaryDark:   themeCtx?.primaryDark   || '#2da080',
    primaryLight:  themeCtx?.primaryLight  || 'rgba(60, 191, 154, 0.10)',
    primaryBorder: themeCtx?.primaryBorder || 'rgba(60, 191, 154, 0.20)',
  }

  const [lineas, setLineas] = useState([])
  const [saving, setSaving] = useState(false)
  const [error, setError] = useState('')

  useEffect(() => {
    if (open && data?.lineas) {
      setLineas(data.lineas.map(l => ({ ...l, factor_editable: l.factor_detectado })))
      setError('')
    }
  }, [open, data])

  if (!open || !data) return null

  const handleFactorChange = (idx, value) => {
    const num = Math.max(0, parseInt(value) || 0)
    setLineas(prev => prev.map((l, i) =>
      i === idx ? { ...l, factor_editable: num, unidades_a_sumar: l.cantidad_pedida * num } : l
    ))
  }

  const handleConfirmar = async () => {
    setSaving(true)
    setError('')
    try {
      const token = localStorage.getItem('token')
      const r = await fetch(`${API_URL}/api/stock/pedido/${data.pedido_id}/aplicar-albaran`, {
        method: 'POST',
        headers: { Authorization: `Bearer ${token}`, 'Content-Type': 'application/json' },
        body: JSON.stringify({
          lineas: lineas.map(l => ({ producto_id: l.producto_id, unidades_a_sumar: l.unidades_a_sumar }))
        }),
      })
      const resp = await r.json()
      if (!r.ok) throw new Error(resp.message || 'Error al aplicar')
      onApplied?.(resp)
    } catch (e) {
      setError(e.message)
    } finally {
      setSaving(false)
    }
  }

  return (
    <div className="fixed inset-0 z-50 flex items-center justify-center bg-black bg-opacity-50 p-4">
      <div className="bg-white rounded-2xl shadow-2xl w-full max-w-4xl max-h-[90vh] overflow-hidden flex flex-col">
        <div className="px-6 py-4 border-b" style={{ backgroundColor: theme.primaryLight }}>
          <h2 className="text-lg font-bold text-gray-800">Verificación de albarán → Stock</h2>
          <p className="text-xs text-gray-600">
            Pedido #{data.pedido_id} · Albarán: <strong>{data.albaran || '—'}</strong>.
            Confirma las unidades reales por embalaje antes de sumar al stock.
          </p>
        </div>

        <div className="flex-1 overflow-y-auto p-4">
          <table className="w-full text-xs">
            <thead className="bg-gray-50">
              <tr>
                <th className="text-left px-3 py-2">Producto</th>
                <th className="text-left px-3 py-2">Unidad base</th>
                <th className="text-right px-3 py-2">Cant. pedida</th>
                <th className="text-right px-3 py-2">Unidades / embalaje</th>
                <th className="text-right px-3 py-2">Total a sumar</th>
              </tr>
            </thead>
            <tbody>
              {lineas.map((l, idx) => (
                <tr key={l.linea_id} className="border-t">
                  <td className="px-3 py-2 text-gray-800 font-medium">{l.nombre}</td>
                  <td className="px-3 py-2 text-gray-500 text-[11px]">{l.unidadbasica || '—'}</td>
                  <td className="px-3 py-2 text-right">{l.cantidad_pedida}</td>
                  <td className="px-3 py-2 text-right">
                    <input
                      type="number"
                      min="1"
                      value={l.factor_editable}
                      onChange={(e) => handleFactorChange(idx, e.target.value)}
                      className="w-20 px-2 py-1 text-right border-2 border-gray-200 rounded focus:outline-none transition-colors"
                      onFocus={(e) => e.target.style.borderColor = theme.primary}
                      onBlur={(e) => e.target.style.borderColor = '#e5e7eb'}
                    />
                  </td>
                  <td className="px-3 py-2 text-right font-bold" style={{ color: theme.primaryDark }}>
                    {l.unidades_a_sumar}
                  </td>
                </tr>
              ))}
            </tbody>
          </table>
          {error && (
            <div className="mt-3 p-2 bg-red-50 border border-red-200 text-red-700 text-sm rounded">{error}</div>
          )}
        </div>

        <div className="px-6 py-4 bg-gray-50 border-t flex items-center justify-end gap-3">
          <button onClick={onClose} disabled={saving} className="px-4 py-2 text-sm text-gray-700 hover:bg-gray-200 rounded-lg">
            Cancelar
          </button>
          <button
            onClick={handleConfirmar}
            disabled={saving}
            className="px-5 py-2 text-sm font-semibold text-white rounded-lg disabled:opacity-50 transition-colors"
            style={{ backgroundColor: theme.primary }}
            onMouseEnter={(e) => !e.currentTarget.disabled && (e.currentTarget.style.backgroundColor = theme.primaryDark)}
            onMouseLeave={(e) => e.currentTarget.style.backgroundColor = theme.primary}
          >
            {saving ? 'Aplicando...' : 'Confirmar y sumar al stock'}
          </button>
        </div>
      </div>
    </div>
  )
}

export default GestionPedidos